import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";
import { ManagedUser } from "types/generated";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { showAssignRoleDrawer } from "views/Account/Settings/User/AssignRoleDrawer";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import useCanManageUsers from "shared/User/access/useCanManageUsers";

import { showUserListRevokeAccessConfirmation } from "./ConfirmationModal";
import styles from "./styles.module.css";

type UsersListItemDropdownProps = {
  handleUserDetailsClick: (details: ManagedUser) => unknown;
  item: ManagedUser;
};

const UsersListItemDropdown = ({ handleUserDetailsClick, item }: UsersListItemDropdownProps) => {
  const { viewer } = useTypedContext(AccountContext);
  const canManageUsers = useCanManageUsers();

  const confirmationModalShow = () => {
    showUserListRevokeAccessConfirmation({
      id: item.id,
      userName: item.username,
    });
  };

  const handleAccessDetailsClick = () => {
    handleUserDetailsClick(item);
  };

  const assignRoles = () => {
    showAssignRoleDrawer({ userId: item.id });
  };

  return (
    <div className={styles.wrapper}>
      <DropdownMenuEllipsis tooltip="User actions">
        <DropdownMenuItem onAction={handleAccessDetailsClick}>See details</DropdownMenuItem>
        <DropdownMenuItem
          analyticsPage={AnalyticsPageOrganization.OrganizationUsers}
          analyticsTitle="Manage Roles Clicked"
          onAction={assignRoles}
        >
          Manage roles
        </DropdownMenuItem>

        {canManageUsers && viewer.id !== item.username && (
          <DropdownMenuItem danger onAction={confirmationModalShow}>
            Revoke access
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </div>
  );
};

export default UsersListItemDropdown;
